import { Box, SxProps, Theme, Typography } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import { contentTitleSx } from '../consts/styles.consts'

interface ContentTitleProps {
  title: string | React.ReactNode
  styles?: SxProps<Theme>
  warn?: boolean
  iconSrc?: string
}

const ContentTitle: React.FC<ContentTitleProps> = ({
  title,
  styles,
  warn,
  iconSrc,
}) => (
  <Box sx={{ ...contentTitleSx, ...styles }}>
    <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      {iconSrc && <img src={iconSrc} alt={'icon'} />}
      <Typography sx={{ fontWeight: '500' }}>{title}</Typography>
    </Box>
    {warn && <img src={getImageSrc('warn')} />}
  </Box>
)

export default observer(ContentTitle)
